import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldTypeConfig, FieldType, FormlyFieldProps } from '@ngx-formly/core';

interface InputProps extends FormlyFieldProps {
  class?: string;
}

@Component({
  standalone: false,
  selector: "formly-field-input",
  templateUrl: "./input.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldInput extends FieldType<FieldTypeConfig<InputProps>> {
  get type() {
    return this.props.type || 'text';
  }
}
